import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export const NoRowsOverlay = ({ objectType, label }) => {
	const theme = useTheme();
	return (
		<Box alignItems='center' width='100%' height='100%' pl='0.5em' pt='0.5em' minHeight='5em'>
			<Typography sx={{ color: theme.palette.text.secondary }}>
				{label ?? `No ${objectType} found.`}
			</Typography>
		</Box>
	);
};

export const NoRowsErrorOverlay = ({ objectType, message }) => (
	<Box
		alignItems='center'
		width='100%'
		height='100%'
		pl='0.5em'
		pt='0.5em'
		pr='0.5em'
		minHeight='5em'
	>
		<Typography sx={{ color: 'red' }}>
			{message || `Error fetching ${objectType}.`}
		</Typography>
	</Box>
);
